import { Modal } from 'antd';
import close from '../../assets/RoundedClose.svg';
import tenderDesign from '../../assets/tenderDesign.svg';
import tenderDefine from '../../assets/tenderDefine.svg';
import tenderLaunch from '../../assets/tenderLaunch.svg';
import Evaluate1 from '../../assets/Evaluate1+2.svg';
import AwardIcon from '../../assets/AwardIcon.svg';
import KickoffIcon from '../../assets/KickoffIcon.svg';
import SupplierAppointment from '../../assets/SupplierAppointment.svg';
import SiteVisit from '../../assets/SiteVisit.svg';
import SuppDocIcon from '../../assets/SuppDocIcon.svg';
import ReviewIcon from '../../assets/ReviewIcon.svg';
import WatchIcon from '../../assets/WatchIcon.svg';
import ConfirmTheDateIcon from '../../assets/ConfirmTheDateIcon.svg';
import AttendIcon from '../../assets/AttendIcon.svg';
import SelectIcon from '../../assets/SelectIcon.svg';
import SignIcon from '../../assets/SignIcon.svg';
import { Dispatch, SetStateAction } from 'react';

const Task = (image: any, name: string, text: string) => {
    return (
        <div className="explanation-task">
            <div className="explanation-task__row">
                <img src={image} className="explanation-task__image" />

                <div className="explanation-task__name">{name}</div>
            </div>
            {text && <div className="explanation-task__text">{text}</div>}
        </div>
    );
};

interface PropsI {
    data: { open: boolean; name: string; key: string };
    setOpenModal: Dispatch<SetStateAction<{ open: boolean; name: string; key: string }>>;
}

export const PhaseExplanation = ({ data, setOpenModal }: PropsI) => {
    return (
        <>
            <Modal
                className="explanation-modal"
                destroyOnClose
                centered
                open={data?.open}
                onCancel={() =>
                    setOpenModal({
                        open: false,
                        name: '',
                        key: ''
                    })
                }
                closeIcon={<img src={close} />}
                footer={<></>}
            >
                <>
                    <div className="explanation-modal__main">
                        <div>
                            <img
                                src={
                                    data?.key === 'define'
                                        ? tenderDefine
                                        : data?.key === 'design'
                                        ? tenderDesign
                                        : data?.key === 'launch'
                                        ? tenderLaunch
                                        : data?.key === 'supplier_appointment'
                                        ? SupplierAppointment
                                        : data?.key === 'evaluate_1_2' ||
                                          data?.key === 'evaluate_3' ||
                                          data?.key === 'evaluate_4'
                                        ? Evaluate1
                                        : data?.key === 'award'
                                        ? AwardIcon
                                        : ''
                                }
                                className="explanation-modal__image"
                            />
                        </div>
                        <div className="explanation-modal__title">{data?.name}</div>
                        <div className="explanation-modal__subtitle">
                            {data?.key === 'define' ? (
                                'During this phase, we focus on understanding your requirements and defining what good looks like from both a solution and supplier perspective'
                            ) : data?.key === 'design' ? (
                                'During this phase, you will review and approve our understanding of your requirements before the Matchmaking Journey is launched'
                            ) : data?.key === 'launch' ? (
                                <>
                                    In this phase, we onboard any remaining suppliers and then go live with the
                                    Matchmaking Journey.
                                    <br />
                                    No action is required from your side, but we may reach out if suppliers submit
                                    questions that need your input. Keep an eye on the chat for any queries that may
                                    come through.
                                </>
                            ) : data?.key === 'supplier_appointment' ? (
                                <>
                                    Your supplier has been selected — now the exciting part begins. Your new supplier
                                    will be in touch to kick off onboarding and get the relationship started.
                                </>
                            ) : data?.key === 'evaluate_1_2' ? (
                                <>
                                    In this phase, the system evaluates onboarded suppliers’ capability profiles against
                                    your criteria, including their experience, capacity, and track record.
                                    <br />
                                    <br />
                                    You will be presented with scores for each supplier, highlighting those best suited
                                    to progress.{' '}
                                </>
                            ) : data?.key === 'evaluate_3' ? (
                                <>
                                    In this phase, suppliers present their company and proposed solution in a pitch
                                    session.
                                    <br />
                                    You score each supplier based on their presentation and offering, and the system
                                    consolidates these scores against your evaluation criteria.
                                </>
                            ) : data?.key === 'evaluate_4' ? (
                                <>
                                    In this phase, suppliers submit their best and final offer on the platform.
                                    <br />
                                    The system consolidates the revised pricing and generates a matchmaking report,
                                    which you can use to present to your board and select your preferred supplier.
                                </>
                            ) : data?.key === 'award' ? (
                                'In this phase, the agreement between you and your appointed supplier is finalised'
                            ) : (
                                ''
                            )}
                        </div>
                        {data?.key !== 'supplier_appointment' && (
                            <>
                                <div className="explanation-modal__what">What You’ll Be Doing:</div>
                                <div className="explanation-modal__tasks">
                                    {data?.key === 'define' && (
                                        <>
                                            {Task(
                                                KickoffIcon,
                                                'Kick-off Questionnaire',
                                                'Share insights about your current setup and future needs by completing a short questionnaire.'
                                            )}
                                            {Task(
                                                SiteVisit,
                                                'Site Visit (if applicable)',
                                                'A representative will visit your site to gather detailed insights about your setup.'
                                            )}
                                        </>
                                    )}
                                    {data?.key === 'design' && (
                                        <>
                                            {Task(
                                                ReviewIcon,
                                                'Specification',
                                                'Review the detailed scope of services, including required tasks, standards, and service frequencies (If applicable)'
                                            )}
                                        </>
                                    )}
                                    {data?.key === 'launch' && (
                                        <>
                                            {Task(
                                                WatchIcon,
                                                'Supplier Questions',
                                                'We may contact you via chat if supplier questions or clarifications arise that require your input. '
                                            )}
                                        </>
                                    )}
                                    {data?.key === 'evaluate_1_2' && (
                                        <>
                                            {Task(
                                                SuppDocIcon,
                                                'Shortlist Suppliers',
                                                'You and your adjudication committee will review the results of Evaluation Gate 1 and decide which suppliers to shortlist.'
                                            )}
                                            {Task(ConfirmTheDateIcon, 'Set Supplier Pitches Dates', '')}
                                        </>
                                    )}
                                    {data?.key === 'evaluate_3' && (
                                        <>
                                            {Task(
                                                AttendIcon,
                                                'Supplier Pitches ',
                                                'You and your adjudication committee will assess supplier pitches and evaluate their solutions. '
                                            )}
                                            {Task(
                                                SuppDocIcon,
                                                'Shortlist Suppliers',
                                                'You and your adjudication committee will review the results of Evaluation Gate 2 and decide which suppliers to shortlist.'
                                            )}
                                        </>
                                    )}
                                    {data?.key === 'evaluate_4' && (
                                        <>{Task(SelectIcon, 'Select Preferred Supplier', '')}</>
                                    )}
                                    {data?.key === 'award' && (
                                        <>
                                            {Task(
                                                SignIcon,
                                                'Sign Supply Agreement ',
                                                'Complete the matchmaking process by signing the agreement with your appointed supplier.'
                                            )}
                                        </>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </>
            </Modal>
        </>
    );
};
